import request from '../../untils/request';

// 获取电表所有商户能耗曲线数据
export function selectMeterUsageDataTotal(data) {
  return request({
    url: '/statisticsAnalysis/selectMeterUsageDataTotal',
    method: 'get',
    params: data,
  });
}
// 获取电表单个商户能耗曲线数据
export function selectMeterUsageData(data) {
  return request({
    url: '/statisticsAnalysis/selectMeterUsageData',
    method: 'get',
    params: data,
  });
}
// 获取水表所有商户能耗曲线数据
export function selectWaterUsageDataTotal(data) {
  return request({
    url: '/statisticsAnalysis/selectWaterUsageDataTotal',
    method: 'get',
    params: data,
  });
}
// 获取电表单个有商户能耗曲线数据
export function selectWaterUsageData(data) {
  return request({
    url: '/statisticsAnalysis/selectWaterUsageData',
    method: 'get',
    params: data,
  });
}
